
/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import { TokenType } from "../types";

// MOCK: This file simulates fetching prices from a Pyth oracle.
// In a real app, this would use @pythnetwork/client to get live on-chain data.
export const fetchTokenPrice = async (symbol: TokenType): Promise<number | null> => {
     await new Promise(resolve => setTimeout(resolve, 100 + Math.random() * 200));
     const prices: Record<string, number> = {
        'SUI': 1.80 + (Math.random() - 0.5) * 0.1,
        'GHOST': 0.15 + (Math.random() - 0.5) * 0.02,
        'wGHOST': 0.15 + (Math.random() - 0.5) * 0.02,
        'SOL': 142.50 + (Math.random() - 0.5) * 5,
        'USDC': 1.00,
        'CETUS': 0.08 + (Math.random() - 0.5) * 0.01,
        'SPL': 5.50 + (Math.random() - 0.5) * 0.2,
    };
    return prices[symbol] ?? null;
}


export const fetchTokenPrices = async (): Promise<Record<TokenType, number>> => {
    const tokens: TokenType[] = ['SUI', 'GHOST', 'wGHOST', 'SOL', 'USDC', 'CETUS', 'SPL'];
    const pricePromises = tokens.map(t => fetchTokenPrice(t));
    const prices = await Promise.all(pricePromises);
    
    const priceMap: Record<TokenType, number> = {} as Record<TokenType, number>;
    tokens.forEach((token, index) => {
        if(prices[index] !== null) {
            priceMap[token] = prices[index]!;
        }
    });
    
    return priceMap;
};